import PropTypes from 'prop-types';
import { DocumentIcon } from 'assets/icons';
import { error } from 'constants/variables';

const DocumentLink = ({ text, type, link, className }) => (
  <a
    className={`fs-15 td-u fw-500 i-fl ai-c ${className || ''}`}
    href={link}
    target="_blank"
    rel="noreferrer">
    <DocumentIcon fillColor={error} />
    <span className="ml-6">
      {text} ({type})
    </span>
  </a>
);
DocumentLink.propTypes = {
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['PDF', 'DOC', 'PPT']).isRequired,
  link: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default DocumentLink;
